import type { LexicalContent, LexicalNode } from '../types/lexical.types';

export function parseLexicalNodes(
  content: LexicalContent | string | null | undefined,
): LexicalNode[] {
  if (typeof content === 'string') {
    try {
      const parsed = JSON.parse(content) as LexicalContent;
      const root = parsed?.root;
      return Array.isArray(root?.children) ? root.children : [];
    } catch {
      return [
        {
          type: 'paragraph',
          children: [{ type: 'text', text: content }],
        },
      ];
    }
  }

  const root = content?.root;
  return Array.isArray(root?.children) ? root.children : [];
}
